import { DeptSelect, Props as DeptSelectProps } from '@/components/DeptSelect';
import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { memo, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { CellProps } from './type';

type Props<TFieldValues extends PaymentRequestForm> =
  DeptSelectProps<TFieldValues> & CellProps;

const InnerDeptSelectCell = <TFieldValues extends PaymentRequestForm>({
  index,
  ...props
}: Props<TFieldValues>) => {
  const cacheKey = useMemo(() => ['row', 'dept', index], [index]);
  const { setValue } = useFormContext<PaymentRequestForm>();
  const setLabelField = useCallback(
    (labelFieldValue: string) => {
      setValue(`invoiceTransactions.${index}.deptName`, labelFieldValue);
    },
    [setValue, index]
  );

  return (
    <DeptSelect<TFieldValues>
      per={500}
      cacheQueryKey={cacheKey}
      {...props}
      setLabelField={setLabelField}
    />
  );
};
InnerDeptSelectCell.displayName = 'InnerDeptSelectCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const DeptSelectCell = memo(
  InnerDeptSelectCell
) as typeof InnerDeptSelectCell;
DeptSelectCell.displayName = 'DeptSelectCell';
